import { db } from '../config/firebase';
import { getDocs, collection, query, where } from 'firebase/firestore';
import { workingDaysSince, getSLAStatus } from '../utils/workingDays';

const STAGE_TO_SLA = {
  pif_submitted: 'pif_analyst_review',
  analyst_review: 'pif_analyst_review',
  peer_review: 'pif_peer_review',
  hop_review: 'hop_review',
  iic_approval: 'iic_hop_approval',
  screening: 'screening',
  due_diligence: 'dd',
};

export async function getSLAConfigsForFund(fundId) {
  const snap = await getDocs(
    query(collection(db, 'sla_config'), where('fund_id', '==', fundId))
  );
  const map = {};
  snap.docs.forEach(d => {
    const data = d.data();
    map[data.stage] = data.target_days;
  });
  return map;
}

export function getDealSLAInfo(deal, slaConfigs) {
  const slaStageId = STAGE_TO_SLA[deal.current_stage];
  const targetDays = slaStageId && slaConfigs ? slaConfigs[slaStageId] : null;
  const daysElapsed = workingDaysSince(deal.stage_entered_at);
  const status = targetDays != null ? getSLAStatus(daysElapsed, targetDays) : 'green';

  return { daysElapsed, targetDays, status };
}
